import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';

class RowItemDanhSachDoiTuongTrung extends React.Component {
  render() {
    let Data = this.props.item || {};
    let UrlCTTTKH = '';
    if (Data.cuocThanhTra && Data.cuocThanhTra.cuocThanhTraId) {
      UrlCTTTKH = Data.cuocThanhTra.cuocThanhTraId;
    }
    let detailUrl = '/thanh-tra/chi-tiet-cuoc-thanh-tra-ke-hoach/'+UrlCTTTKH;
    if (Data.cuocThanhTra && Data.cuocThanhTra.keHoachThanhTraInfo && Data.cuocThanhTra.keHoachThanhTraInfo.keHoachThanhTraId) {
      detailUrl = '/thanh-tra/chi-tiet-ke-hoach-trung/'+Data.cuocThanhTra.keHoachThanhTraInfo.keHoachThanhTraId;
    }
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <Link className='txt-underline txt-regular' to={detailUrl}>
            {Data.doiTuongThanhTraTrung ? Data.doiTuongThanhTraTrung.ten : ''}
          </Link>
        </td>
        <td>{Data.cuocThanhTra && Data.cuocThanhTra.noiDungThanhTra ? Data.cuocThanhTra.noiDungThanhTra : ''}</td>
        <td>{Data.cuocThanhTra && Data.cuocThanhTra.hinhThucThanhTraChuyenNganhInfo !== null ? Data.cuocThanhTra.hinhThucThanhTraChuyenNganhInfo.text : ''}</td>
        <td>{Data.cuocThanhTra && Data.cuocThanhTra.thoiHanThanhTra ? Data.cuocThanhTra.thoiHanThanhTra : ''}</td>
        <td>{Data.cuocThanhTra && Data.cuocThanhTra.kyThanhTra ? Data.cuocThanhTra.kyThanhTra : ''}</td>
        <td>{Data.cuocThanhTra && Data.cuocThanhTra.thoiGianTienHanh ? Data.cuocThanhTra.thoiGianTienHanh : ''}</td>
        <td>{Data.cuocThanhTra && Data.cuocThanhTra.donViInfo ? Data.cuocThanhTra.donViInfo.ten : ''}</td>
        <td>{Data.cuocThanhTra && Data.cuocThanhTra.keHoachThanhTraInfo ? Data.cuocThanhTra.keHoachThanhTraInfo.namThanhTra : (Data.cuocThanhTra.namThanhTra || '' )}</td>
      </tr>
    );
  }
}

export default RowItemDanhSachDoiTuongTrung;



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemDanhSachDoiTuongTrung.jsx